export default "__VITE_ASSET__47ioW$IC__"